import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import '../Roles/roles.css';
import { ROUTES } from '../../../constants/routes';
import { usePermissions } from '../../../hooks/usePermissions';
import { EmptyState } from '../../../components/common/EmptyState/EmptyState';
import { PremiumGrants } from './PremiumGrants';

/**
 * /dashboard/premium — the caller's own organization. Without one (platform
 * staff reaching it by URL) there is nothing to load; point them at the
 * per-organization page instead of surfacing the API's 404 text.
 */
export const PremiumV2 = () => {
  const { t } = useTranslation();
  const { organization } = usePermissions();
  if (!organization) {
    return <EmptyState icon="workspace_premium" message={t('dashboard.premium.noOrganization')} />;
  }
  return <PremiumGrants />;
};

/** /dashboard/organizations/:organizationId/premium — platform admins. */
export const OrganizationPremiumV2 = () => {
  const { t } = useTranslation();
  const { organizationId } = useParams<{ organizationId: string }>();
  return (
    <>
      <Link to={`/${ROUTES.DASHBOARD}/${ROUTES.DASH_ORGANIZATIONS}`} className="back-link">
        <span className="material-symbols-outlined" aria-hidden="true">arrow_back</span>
        {t('dashboard.sidebar.organizations')}
      </Link>
      <PremiumGrants key={organizationId} organizationId={organizationId} />
    </>
  );
};
